import React from 'react';
import {Card, Flex} from "antd";
import {BackButton} from "../../../../shared";
import style from "./CategoryListHeader.module.scss";
import {StyledCard} from "./CategoryListheader.styled";

const CategoryListHeader = () => {
    return (
        <StyledCard >
            <Flex justify={"space-between"} align={"center"} gap={"middle"}>
                <Flex gap={"small"} align={"center"}>
                   <BackButton/>
                   <span>دسته بندی</span>
               </Flex>
                <img width={20} src={require("assets/Logo/logoPink.png")}/>
            </Flex>
        </StyledCard>
    )

};

export default CategoryListHeader;